import { useTheme } from "../theme/ThemeProvider";

// Three-state cycle. Icons inlined as small SVGs (matches the skill's
// "no emoji as icons" rule and avoids a new dep).
function SunIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="h-4 w-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="h-4 w-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
    </svg>
  );
}

function SystemIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="h-4 w-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </svg>
  );
}

interface Props {
  /** When true, render only the icon (sidebar-collapsed mode); else
   *  include the label so the meaning is obvious in expanded mode. */
  compact?: boolean;
}

export function ThemeToggle({ compact = false }: Props) {
  const { theme, cycleTheme } = useTheme();

  const icon =
    theme === "light" ? <SunIcon /> : theme === "dark" ? <MoonIcon /> : <SystemIcon />;
  const label =
    theme === "light" ? "Light" : theme === "dark" ? "Dark" : "System";

  return (
    <button
      type="button"
      onClick={cycleTheme}
      title={`Theme: ${label} (click to cycle)`}
      aria-label={`Theme: ${label}. Click to switch.`}
      className={`flex items-center gap-2 rounded-md px-2 py-2 text-xs uppercase tracking-wide text-fg-muted transition hover:bg-bg-hover hover:text-fg ${
        compact ? "justify-center" : "w-full"
      }`}
    >
      <span aria-hidden="true">{icon}</span>
      {!compact && <span>{label}</span>}
    </button>
  );
}
